import React from 'react';
import ModalErrorInformation from '../../../../basics/ModalErrorInformation';
import { EnseignantValidationErrorDto } from '../../../../../services/generated/FrontOffice-api';
import { useTranslation } from 'react-i18next';

interface ModalValidationEnseignantsProps {
	isOpen: boolean;
	onCancel: () => void;
	errorsValidation: EnseignantValidationErrorDto[];
}

const ModalValidationEnseignants: React.FunctionComponent<ModalValidationEnseignantsProps> = ({
	isOpen,
	onCancel,
	errorsValidation
}) => {
	const { t } = useTranslation();

	return (<ModalErrorInformation
		isOpen={isOpen}
		onCancel={onCancel}
		title={t('common.validation-error.title')}
		cancelButtonLabel={t('common.return')}
	>
		<div className="modal__item">
			<ul>
				{errorsValidation?.map((e: EnseignantValidationErrorDto, i:number) => (
					<li key={i}>
						{t('createFolder.enseignants.errors.contrat', {name: e.contrat})}
						{t('createFolder.enseignants.errors.number', {number: e.numberEnseignantRequired})}
					</li>
				))}
			</ul>
		</div>
	</ModalErrorInformation>);
}

export default ModalValidationEnseignants;